import React from 'react'

export interface MDXProps {
  // MDX-Filename
  file: string
  // ClassName for Container -> No Class = No Container
  containerClass?: string
}

export const MDX = ({ file, containerClass }: MDXProps) => {
  const Content = require('../../text/' + file).default
  // console.log(file)
  if (containerClass) {
    return (
      <div className={containerClass}>
        <Content className={containerClass} />
      </div>
    )
  }
  return <Content />
}
